export default __webpack_public_path__ + "static/media/cloud_cloudez.d62e7c5b.svg";